<template>
    <div>
    <flash-message  variant="success"></flash-message>
    <flash-message  variant="danger"></flash-message>
    </div>
</template>
<script>
    export default {
	name: "flashMessages",
        data() {
            return {
                errorMessage: "",
                infoError: false,
                variant: "success",
                setMessage: "0",
            }
        },
    }
</script>
